/* eslint-disable no-console */
import { Flex, Text } from '@chakra-ui/react';
import React, { useState } from 'react';

import { finleyAssert } from '@finley-technologies/common';
import { DbTable } from '@finley-technologies/finley-types';
import { TapeBuilderUI } from '@finley-technologies/tape-builder';
import type { ValleyFileGraph } from '@finley-technologies/valley-bank-utils';
import { valleyFiles } from '@finley-technologies/valley-bank-utils';

import { getArtifactInstanceBySlug, useGraph } from '../GraphContext';
import { FilesDownloader } from './FileDownloader';
import { ValleyFileQuery } from './ValleyFileQuery';

type ValleyBankPanelProps = {
  configuration: DbTable.ArtifactWithSlugs;
};
export const ValleyBankPanel = (props: ValleyBankPanelProps) => {
  const graphContext = useGraph();
  const ingestNode = TapeBuilderUI.getUITapeNodeByArtifactType(
    'valleyBankIngest',
  );

  const [
    valleyFileGraph,
    setValleyFileGraph,
  ] = useState<ValleyFileGraph | null>(null);

  const handleAllFilesDownloaded = (graph: ValleyFileGraph) => {
    setValleyFileGraph(graph);
  };

  finleyAssert(
    ingestNode.artifactType === 'valleyBankIngest',
    'Valley Bank Ingest UI Node must be of type valleyBankIngest',
  );

  const {
    configuration: { configuration },
  } = props;
  const uiConfig = {
    ...configuration,
    artifactSlug: 'placeHolderSlug',
  };

  finleyAssert(
    ingestNode.isConfig(uiConfig),
    'Valley Bank Ingest UI Node must match configuration',
  );

  const { artifactSlug: _unused, ...vanFileSlugs } = uiConfig;

  const artifactCsvUrls = Object.entries(vanFileSlugs).map(
    ([slugKey, slugValue]) => {
      finleyAssert(
        valleyFiles.isValleyFile(slugKey),
        `Invalid Valley File slug: ${slugKey}`,
      );
      const instance = getArtifactInstanceBySlug({
        slug: slugValue,
        graphContext,
      });
      return {
        slugKey,
        slugValue,
        download:
          instance && instance.downloads.length > 0
            ? instance.downloads[0]
            : null,
        status: 'pending', // Initial fetch status
      };
    },
  );

  return (
    <Flex
      flexDirection="column"
      width="100%"
      border="1px solid #ccc"
      padding="10px"
    >
      <Text mb="4">Valley Bank data analysis.</Text>
      {!valleyFileGraph ? (
        <FilesDownloader
          files={artifactCsvUrls}
          onAllFilesDownloaded={handleAllFilesDownloaded}
        />
      ) : (
        <ValleyFileQuery graph={valleyFileGraph} />
      )}
    </Flex>
  );
};
